import Persister from '@pollyjs/persister';

export default class PollyAdapterPersister extends Persister {
  static get id() {
    return 'custom-persister';
  }

  static get name() {
    return this.id;
  }

  saveRecording(recordingId, data) {
    window.polly_har = data;
  }

  findRecording() {
  }

  get db() {
    return window.polly_har;
  }
}
